import { Heading, Paragraph, Stack, Tag } from '@99designs/emu';
import { FormattedMessage } from '@99designs/frontend-components/i18n';
import { Price } from '@99designs/marketing-ui';
import { ProductGroupType } from '../../types';
import StarRatings from '../Rating/StarRatings';
import type { Price as PriceType } from '../../types';

type Props = {
    title: string;
    price: PriceType;
    subtitle: string;
    description: string;
    type?: ProductGroupType;
    showRating?: boolean;
};

export function ProductGroupSummary({
    title,
    price,
    subtitle,
    description,
    type,
    showRating,
}: Props) {
    return (
        <Stack space="1.5bu">
            <Heading appearanceLevel={3} accessibilityLevel={1}>
                {title}
            </Heading>
            {showRating && <StarRatings />}
            <Heading appearanceLevel={5} accessibilityLevel={2} as="p">
                {type && type === ProductGroupType.FixedPrice ? (
                    <Price amount={price.amountInCents} currency={price.currency} />
                ) : (
                    <FormattedMessage
                        message={__('Starting from {price}')}
                        values={{
                            price: <Price amount={price.amountInCents} currency={price.currency} />,
                        }}
                    />
                )}
            </Heading>
            {type && type === ProductGroupType.FixedPrice && (
                <Tag appearance="filled">{__('Fixed price package')}</Tag>
            )}
            <Stack space="0.75bu">
                <Heading appearanceLevel={4} accessibilityLevel={2} as="p">
                    {subtitle}
                </Heading>
                <Paragraph>{description}</Paragraph>
            </Stack>
        </Stack>
    );
}
